import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useAuth } from '../../../App';

const AUTH_HREFS = ['/login', '/signin', '/signup', '/sign-in', '/sign-up', '/auth'];

/** CTA block — final call-to-action. data: { headline, body?, cta_primary, cta_secondary? } */
export default function CTA({ data = {} }) {
  const { headline = '', body, cta_primary, cta_secondary } = data;
  return (
    <section className="py-16" data-testid="site-block-cta">
      <div className="max-w-4xl mx-auto px-6">
        <div className="rounded-3xl orka-surface-raised border orka-border-default p-10 lg:p-14 text-center">
          {headline && (
            <h2 className="text-2xl lg:text-4xl font-bold tracking-tight orka-text-primary">{headline}</h2>
          )}
          {body && (
            <p className="mt-4 text-base lg:text-lg orka-text-secondary max-w-2xl mx-auto">{body}</p>
          )}
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            {cta_primary?.label && (
              <Btn href={cta_primary.href} variant="primary" testId="site-block-cta-primary">
                {cta_primary.label}
                <ArrowRight className="w-4 h-4" />
              </Btn>
            )}
            {cta_secondary?.label && (
              <Btn href={cta_secondary.href} variant="secondary" testId="site-block-cta-secondary">
                {cta_secondary.label}
              </Btn>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

function Btn({ href = '#', variant = 'primary', children, testId }) {
  const { login } = useAuth();
  const classes =
    variant === 'primary'
      ? 'inline-flex items-center gap-2 h-11 px-6 rounded-full bg-slate-900 dark:bg-slate-100 text-white dark:text-slate-900 font-medium text-sm orka-transition-colors hover:bg-slate-800 dark:hover:bg-white orka-focus-ring'
      : 'inline-flex items-center gap-2 h-11 px-6 rounded-full border orka-border-default orka-text-primary font-medium text-sm orka-transition-colors hover:orka-surface-subtle orka-focus-ring';
  const normalized = (href || '').toLowerCase();
  if (AUTH_HREFS.includes(normalized)) {
    return (
      <button type="button" onClick={() => login()} className={classes} data-testid={testId}>
        {children}
      </button>
    );
  }
  if (href?.startsWith('/')) {
    return <Link to={href} className={classes} data-testid={testId}>{children}</Link>;
  }
  return <a href={href} className={classes} data-testid={testId}>{children}</a>;
}
